<template>
  <div class="admin-alumnos-container">
    <CardPrime class="admin-alumnos-card">
      <template #title>
        <div class="card-header">
          <h3 class="card-title">Administración de Alumnos</h3>
        </div>
      </template>
      <template #content>
        <UserTable
          :usuarios="usuarios"
          :rows="lazyParams.rows"
          :totalRecords="totalRecords"
          :filters="filters"
          :loading="loading"
          @page="onPage"
          @update:filters="updateFilters"
          @editarUsuario="abrirEditarUsuario"
          @clonarUsuario="abrirDialogoClonar"
          @modificarCurso="abrirModificarCurso"
          @agregarAdicionales="abrirAgregarAdicionales"
          v-model:selectedUsuarios="selectedUsuarios"
        />
        <div v-if="selectedUsuarios.length > 0" class="mt-4">
          <!-- Sección para actualización masiva de principal y casa -->
          <div class="form-field">
            <label for="curso-principal-select" class="block text-sm font-medium text-gray-700">Curso Principal</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona el Curso Principal'"
              :error="errors.nuevoCursoPrincipal"
              :modelValue="nuevoCursoPrincipal"
              @update:modelValue="nuevoCursoPrincipal = $event"
            />
            <small v-if="mostrarErrores && errors.nuevoCursoPrincipal" class="p-error">{{ errors.nuevoCursoPrincipal }}</small>
          </div>
          <div class="form-field">
            <label for="casa-select" class="block text-sm font-medium text-gray-700">Casa</label>
            <SingleCasaCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona la Casa'"
              :error="errors.nuevoCasa"
              :modelValue="nuevoCasa"
              @update:modelValue="nuevoCasa = $event"
            />
            <small v-if="mostrarErrores && errors.nuevoCasa" class="p-error">{{ errors.nuevoCasa }}</small>
          </div>
          <div class="form-field">
            <label for="cursos-adicionales-select" class="block text-sm font-medium text-gray-700">Cursos Adicionales</label>
            <MultiCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona los Cursos Adicionales'"
              :error="errors.nuevosCursosAdicionales"
              :modelValue="nuevosCursosAdicionales"
              @update:modelValue="nuevosCursosAdicionales = $event"
            />
            <small v-if="mostrarErrores && errors.nuevosCursosAdicionales" class="p-error">{{ errors.nuevosCursosAdicionales }}</small>
          </div>
          <ButtonPrime
            label="Actualizar Cursos Seleccionados"
            @click="openConfirmModal"
            class="mt-2"
          />
          <!-- Sección para agregar cursos adicionales -->
          <div class="form-field mt-4">
            <label for="cursos-adicionales-agregar" class="block text-sm font-medium text-gray-700">Agregar Cursos Adicionales</label>
            <MultiCursoCombo
              :mostrarErrores="mostrarErroresAdicionales"
              :tooltip="'Selecciona los Cursos Adicionales a agregar'"
              :error="errorsAdicionales.nuevosCursosAdicionales"
              :modelValue="nuevosCursosAdicionales"
              @update:modelValue="nuevosCursosAdicionales = $event"
            />
            <small v-if="mostrarErroresAdicionales && errorsAdicionales.nuevosCursosAdicionales" class="p-error">{{ errorsAdicionales.nuevosCursosAdicionales }}</small>
          </div>
          <ButtonPrime
            label="Agregar Cursos Adicionales Seleccionados"
            @click="openConfirmModalAdicionales"
            class="mt-2"
          />
        </div>
        <!-- Modal para actualización masiva -->
        <DialogPrime
          header="Confirmar Actualización de Cursos"
          v-model:visible="showConfirmModal"
          :modal="true"
          :closable="false"
        >
          <p>
            ¿Estás seguro de actualizar los cursos de {{ selectedUsuarios.length }} alumno(s) con el curso principal, casa y cursos adicionales seleccionados?
          </p>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarActualizacionMasiva" />
            <ButtonPrime label="Cancelar" @click="closeConfirmModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal para agregar cursos adicionales masivos -->
        <DialogPrime
          header="Confirmar Agregar Cursos Adicionales"
          v-model:visible="showConfirmModalAdicionales"
          :modal="true"
          :closable="false"
        >
          <p>
            ¿Estás seguro de agregar {{ nuevosCursosAdicionales.length }} cursos adicionales a {{ selectedUsuarios.length }} alumno(s)?
          </p>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarAgregarAdicionales" />
            <ButtonPrime label="Cancelar" @click="closeConfirmModalAdicionales" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal para modificar curso individual -->
        <DialogPrime
          header="Modificar Curso de Alumno"
          v-model:visible="showModificarCursoModal"
          :modal="true"
          :closable="false"
        >
          <div class="form-field">
            <label for="curso-principal-individual" class="block text-sm font-medium text-gray-700">Curso Principal</label>
            <SingleCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona el Curso Principal'"
              :error="errors.cursoPrincipalIndividual"
              :modelValue="cursoPrincipalIndividual"
              @update:modelValue="cursoPrincipalIndividual = $event"
            />
            <small v-if="mostrarErrores && errors.cursoPrincipalIndividual" class="p-error">{{ errors.cursoPrincipalIndividual }}</small>
          </div>
          <div class="form-field">
            <label for="casa-individual" class="block text-sm font-medium text-gray-700">Casa</label>
            <SingleCasaCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona la Casa'"
              :error="errors.casaIndividual"
              :modelValue="casaIndividual"
              @update:modelValue="casaIndividual = $event"
            />
            <small v-if="mostrarErrores && errors.casaIndividual" class="p-error">{{ errors.casaIndividual }}</small>
          </div>
          <div class="form-field">
            <label for="cursos-adicionales-individual" class="block text-sm font-medium text-gray-700">Cursos Adicionales</label>
            <MultiCursoCombo
              :mostrarErrores="mostrarErrores"
              :tooltip="'Selecciona los Cursos Adicionales'"
              :error="errors.cursosAdicionalesIndividual"
              :modelValue="cursosAdicionalesIndividual"
              @update:modelValue="cursosAdicionalesIndividual = $event"
            />
            <small v-if="mostrarErrores && errors.cursosAdicionalesIndividual" class="p-error">{{ errors.cursosAdicionalesIndividual }}</small>
          </div>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarActualizacionIndividual" />
            <ButtonPrime label="Cancelar" @click="closeModificarCursoModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal para agregar cursos adicionales individual -->
        <DialogPrime
          header="Agregar Cursos Adicionales a Alumno"
          v-model:visible="showAgregarAdicionalesModal"
          :modal="true"
          :closable="false"
        >
          <div class="form-field">
            <label for="cursos-adicionales-individual" class="block text-sm font-medium text-gray-700">Cursos Adicionales a Agregar</label>
            <MultiCursoCombo
              :mostrarErrores="mostrarErroresAdicionales"
              :tooltip="'Selecciona los Cursos Adicionales a agregar'"
              :error="errorsAdicionales.cursosAdicionalesIndividual"
              :modelValue="cursosAdicionalesIndividual"
              @update:modelValue="cursosAdicionalesIndividual = $event"
            />
            <small v-if="mostrarErroresAdicionales && errorsAdicionales.cursosAdicionalesIndividual" class="p-error">{{ errorsAdicionales.cursosAdicionalesIndividual }}</small>
          </div>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarAgregarAdicionalesIndividual" />
            <ButtonPrime label="Cancelar" @click="closeAgregarAdicionalesModal" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <UserDialog
          :visible="usuarioDialog"
          :usuario="usuario"
          :perfiles="perfiles"
          :cerrarDialog="cerrarDialog"
          :guardarUsuario="guardarUsuario"
        />
        <DialogPrime
          v-model:visible="clonarDialogVisible"
          header="Selecciona los cursos para el nuevo usuario"
          :modal="true"
          :style="{ width: '50vw' }"
        >
          <ul>
            <li v-for="curso in cursos" :key="curso.curso_id">
              <CheckboxPrime v-model="cursosSeleccionados" :value="curso.curso_id" :binary="false"></CheckboxPrime>
              <strong>{{ curso.curso }}</strong>
              <ul>
                <li v-for="asignatura in curso.asignaturas" :key="asignatura.asignatura_id">
                  {{ asignatura.asignatura }}
                </li>
              </ul>
            </li>
          </ul>
          <template #footer>
            <ButtonPrime label="Generar Alumno" @click="generarNuevoAlumno('alumno')" />
            <ButtonPrime label="Generar Docente" @click="generarNuevoAlumno('docente')" />
            <ButtonPrime label="Cancelar" @click="cerrarDialogoClonar" />
          </template>
        </DialogPrime>
        <ContratoUsuarioDialog
          v-model:visible="editarContratoDialogVisible"
          :usuarioId="usuarioSeleccionado"
          @contrato-actualizado="actualizarListaUsuarios"
        />
        <ToastPrime />
      </template>
    </CardPrime>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import usuarioService from '@/services/UsuarioService';
import CardPrime from 'primevue/card';
import ButtonPrime from 'primevue/button';
import DialogPrime from 'primevue/dialog';
import ToastPrime from 'primevue/toast';
import CheckboxPrime from 'primevue/checkbox';
import UserTable from '@/components/user/UserTable.vue';
import UserDialog from '@/components/user/UserDialog.vue';
import ContratoUsuarioDialog from '@/components/user/ContratoUsuarioDialog.vue';
import { ref } from 'vue';
import axios from 'axios';

export default {
  components: {
    CardPrime,
    ButtonPrime,
    DialogPrime,
    ToastPrime,
    CheckboxPrime,
    UserTable,
    UserDialog,
    ContratoUsuarioDialog
  },
  data() {
    return {
      usuario_clonar: null,
      usuarios: [],
      usuario: {},
      usuarioDialog: false,
      clonarDialogVisible: false,
      cursos: [],
      totalRecords: 0,
      loading: false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        colegio: '',
        curso: ''
      },
      lazyParams: {
        first: 0,
        rows: 20,
        page: 1
      },
      perfiles: [
        { Id: 1, Glosa: 'Docente' },
        { Id: 2, Glosa: 'Alumno' }
      ],
      cursosSeleccionados: [],
      editarContratoDialogVisible: ref(false),
      usuarioSeleccionado: ref(null),
      selectedUsuarios: [],
      nuevoCursoPrincipal: '',
      nuevoCasa: '',
      nuevosCursosAdicionales: [],
      showConfirmModal: false,
      showConfirmModalAdicionales: false,
      showModificarCursoModal: false,
      showAgregarAdicionalesModal: false,
      cursoPrincipalIndividual: '',
      casaIndividual: '',
      cursosAdicionalesIndividual: [],
      errors: {
        nuevoCursoPrincipal: '',
        nuevoCasa: '',
        nuevosCursosAdicionales: '',
        cursoPrincipalIndividual: '',
        casaIndividual: '',
        cursosAdicionalesIndividual: ''
      },
      errorsAdicionales: {
        nuevosCursosAdicionales: '',
        cursosAdicionalesIndividual: ''
      },
      mostrarErrores: false,
      mostrarErroresAdicionales: false,
      usuarioModificar: null
    };
  },
  methods: {
    async cargarUsuarios() {
      this.loading = true;
      try {
        const response = await usuarioService.getAlumnosPorCurso({
          IdColegio: this.filters.colegio || 0,
          IdCurso: this.filters.curso || 0,
          Page: this.lazyParams.page,
          Rows: this.lazyParams.rows
        });
        this.usuarios = response.data.items.map(usuario => ({
          ...usuario,
          Nombre: usuario.nombre,
          ApellidoPaterno: usuario.apellido_paterno,
          ApellidoMaterno: usuario.apellido_materno,
          IdentificadorRut: usuario.identificador_rut,
          Email: usuario.email,
          NombreCompleto: `${usuario.nombre} ${usuario.apellido_paterno}`
        }));
        this.totalRecords = response.data.totalRecords;
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
      } finally {
        this.loading = false;
      }
    },
    updateFilters(newFilters) {
      this.filters = {
        ...this.filters,
        colegio: newFilters.colegio,
        curso: newFilters.curso
      };
      this.lazyParams.page = 1;
      this.lazyParams.first = 0;
      this.cargarUsuarios();
    },
    onPage(event) {
      this.lazyParams = {
        ...this.lazyParams,
        first: event.first,
        rows: event.rows,
        page: Math.floor(event.first / event.rows) + 1
      };
      this.cargarUsuarios();
    },
    abrirDialogoClonar(usuario) {
      this.usuario_clonar = usuario.id_usuario;
      this.clonarDialogVisible = true;
      this.obtenerCursos(usuario.id_usuario);
    },
    async obtenerCursos(usuarioId) {
      try {
        const response = await usuarioService.getCursosPorUsuario(usuarioId);
        this.cursos = this.agruparCursosYAsignaturas(response.data);
      } catch (error) {
        console.error('Error al obtener cursos:', error);
      }
    },
    agruparCursosYAsignaturas(cursos) {
      const agrupados = {};
      cursos.forEach(item => {
        const { id_curso, id_asignatura, curso: nombreCurso, asignatura: nombreAsignatura } = item;
        if (!agrupados[id_curso]) {
          agrupados[id_curso] = {
            curso_id: id_curso,
            curso: nombreCurso,
            asignaturas: []
          };
        }
        agrupados[id_curso].asignaturas.push({
          asignatura_id: id_asignatura,
          asignatura: nombreAsignatura
        });
      });
      return Object.values(agrupados);
    },
    generarNuevoAlumno(tipo) {
      if (this.cursosSeleccionados.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un curso.',
          life: 3000
        });
        return;
      }
      this.$router.push({
        name: 'admin-alumnos-nuevo',
        params: { id_usuario: this.usuario_clonar },
        query: { cursos: this.cursosSeleccionados.join(','), tipo: tipo }
      });
      this.cerrarDialogoClonar();
    },
    cerrarDialogoClonar() {
      this.clonarDialogVisible = false;
      this.cursosSeleccionados = [];
    },
    abrirEditarUsuario(data) {
      this.usuario = { ...data };
      this.usuarioDialog = true;
    },
    cerrarDialog() {
      this.usuarioDialog = false;
      this.usuario = {};
    },
    async guardarUsuario() {
      try {
        if (this.usuario.Id) {
          await usuarioService.actualizarUsuario(this.usuario.Id, this.usuario);
        } else {
          await usuarioService.crearUsuario(this.usuario);
        }
        this.cerrarDialog();
        this.cargarUsuarios();
      } catch (error) {
        console.error('Error al guardar usuario:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo guardar el usuario.',
          life: 3000
        });
      }
    },
    abrirDialogoEditarContrato(usuario) {
      this.usuarioSeleccionado = usuario.id_usuario;
      this.editarContratoDialogVisible = true;
    },
    actualizarListaUsuarios() {
      this.cargarUsuarios();
    },
    openConfirmModal() {
      this.errors.nuevoCursoPrincipal = !this.nuevoCursoPrincipal ? 'Debes seleccionar un curso principal' : '';
      this.errors.nuevoCasa = !this.nuevoCasa ? 'Debes seleccionar una casa' : '';
      this.errors.nuevosCursosAdicionales = this.nuevosCursosAdicionales.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErrores = true;
      if (this.errors.nuevoCursoPrincipal || this.errors.nuevoCasa || this.errors.nuevosCursosAdicionales) {
        return;
      }
      if (!this.selectedUsuarios.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un alumno.',
          life: 3000
        });
        return;
      }
      this.mostrarErrores = false;
      this.showConfirmModal = true;
    },
    closeConfirmModal() {
      this.showConfirmModal = false;
    },
    async confirmarActualizacionMasiva() {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/cursos-detalle', {
          IdUsuarios: this.selectedUsuarios.map(u => parseFloat(u.id_usuario)),
          IdCursoPrincipal: parseFloat(this.nuevoCursoPrincipal),
          IdCasa: parseFloat(this.nuevoCasa),
          CursosAdicionales: this.nuevosCursosAdicionales.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
        this.selectedUsuarios = [];
        this.nuevoCursoPrincipal = '';
        this.nuevoCasa = '';
        this.nuevosCursosAdicionales = [];
      } catch (error) {
        console.error('Error al actualizar cursos:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeConfirmModal();
      }
    },
    openConfirmModalAdicionales() {
      this.errorsAdicionales.nuevosCursosAdicionales = this.nuevosCursosAdicionales.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErroresAdicionales = true;
      if (this.errorsAdicionales.nuevosCursosAdicionales) {
        return;
      }
      if (!this.selectedUsuarios.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un alumno.',
          life: 3000
        });
        return;
      }
      this.mostrarErroresAdicionales = false;
      this.showConfirmModalAdicionales = true;
    },
    closeConfirmModalAdicionales() {
      this.showConfirmModalAdicionales = false;
    },
    async confirmarAgregarAdicionales() {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/contrato-detalle/agregar-cursos', {
          IdUsuarios: this.selectedUsuarios.map(u => parseFloat(u.id_usuario)),
          CursosAdicionales: this.nuevosCursosAdicionales.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
        this.selectedUsuarios = [];
        this.nuevosCursosAdicionales = [];
      } catch (error) {
        console.error('Error al agregar cursos adicionales:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeConfirmModalAdicionales();
      }
    },
    abrirModificarCurso(usuario) {
      this.usuarioModificar = usuario;
      this.showModificarCursoModal = true;
    },
    closeModificarCursoModal() {
      this.showModificarCursoModal = false;
      this.cursoPrincipalIndividual = '';
      this.casaIndividual = '';
      this.cursosAdicionalesIndividual = [];
      this.usuarioModificar = null;
    },
    async confirmarActualizacionIndividual() {
      this.errors.cursoPrincipalIndividual = !this.cursoPrincipalIndividual ? 'Debes seleccionar un curso principal' : '';
      this.errors.casaIndividual = !this.casaIndividual ? 'Debes seleccionar una casa' : '';
      this.errors.cursosAdicionalesIndividual = this.cursosAdicionalesIndividual.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErrores = true;
      if (this.errors.cursoPrincipalIndividual || this.errors.casaIndividual || this.errors.cursosAdicionalesIndividual) {
        return;
      }
      this.mostrarErrores = false;
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/cursos-detalle', {
          IdUsuarios: [parseFloat(this.usuarioModificar.id_usuario)],
          IdCursoPrincipal: parseFloat(this.cursoPrincipalIndividual),
          IdCasa: parseFloat(this.casaIndividual),
          CursosAdicionales: this.cursosAdicionalesIndividual.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
      } catch (error) {
        console.error('Error al actualizar curso:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeModificarCursoModal();
      }
    },
    abrirAgregarAdicionales(usuario) {
      this.usuarioModificar = usuario;
      this.showAgregarAdicionalesModal = true;
    },
    closeAgregarAdicionalesModal() {
      this.showAgregarAdicionalesModal = false;
      this.cursosAdicionalesIndividual = [];
      this.usuarioModificar = null;
    },
    async confirmarAgregarAdicionalesIndividual() {
      this.errorsAdicionales.cursosAdicionalesIndividual = this.cursosAdicionalesIndividual.length === 0 ? 'Debes seleccionar al menos un curso adicional' : '';
      this.mostrarErroresAdicionales = true;
      if (this.errorsAdicionales.cursosAdicionalesIndividual) {
        return;
      }
      this.mostrarErroresAdicionales = false;
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('http://localhost:54494/api/v2/save/alumno/contrato-detalle/agregar-cursos', {
          IdUsuarios: [parseFloat(this.usuarioModificar.id_usuario)],
          CursosAdicionales: this.cursosAdicionalesIndividual.map(c => parseFloat(c)),
          IdUsuarioActualizador: 789 // Reemplazar con ID real
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: data.Mensaje,
          life: 3000
        });
        this.cargarUsuarios();
      } catch (error) {
        console.error('Error al agregar cursos adicionales:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response ? error.response.data.ExceptionMessage : error.message,
          life: 3000
        });
      } finally {
        this.closeAgregarAdicionalesModal();
      }
    }
  },
  mounted() {
    this.cargarUsuarios();
  }
};
</script>

<style scoped>
.admin-alumnos-container {
  padding: 1rem;
}
.admin-alumnos-card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.card-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: #1a202c;
}
.form-field {
  margin-bottom: 1rem;
}
.form-field label {
  display: block;
  font-size: 0.875rem;
  font-weight: medium;
  color: #4a5568;
  margin-bottom: 0.25rem;
}
</style>